<template>
    <div>
        <PimProductTableList class="pim-product-table-list--info-material" :headers="headers" v-if="materials && materials.length">
            <PimProductTableListRow v-for="(material, index) in materials" :key="material.pim_id">
                <PimProductTableListColumn>
                    <GlobalInlineTile :title="'<b>' + material.title + '</b>'" :image="material.image_src"/>
                </PimProductTableListColumn>
                <PimProductTableListColumn>
                    <span>{{material.art}}</span>
                </PimProductTableListColumn>
                <PimProductTableListColumn>
                    <span class="d-md-none">
                        <GlobalInlineTile :image-alternative="`${imageAlternative}:`" :title="`${(material.format ? material.format : '--')}`"/>
                    </span>
                    <span class="d-none d-md-block">
                        <template v-if="material.format">{{material.format}}</template><template v-else>--</template>
                    </span>
                </PimProductTableListColumn>
                <PimProductTableListColumn>
                    <slot name="actions" :item="material" :index="index">
                        Please override the "actions" slot in your template. The "item" and the "index" are passed as properties.
                    </slot>
                </PimProductTableListColumn>
            </PimProductTableListRow>
        </PimProductTableList>
    </div>
</template>

<script>

import GlobalInlineTile from "@global/global-elements/global-inline-tile/global-inline-tile.vue";
import PimProductTableList from "@src/Resources/epim/Partials/PimProductTableList/pim-product-table-list.vue";
import PimProductTableListRow from "@src/Resources/epim/Partials/PimProductTableList/pim-product-table-list-row.vue";
import PimProductTableListColumn from "@src/Resources/epim/Partials/PimProductTableList/pim-product-table-list-column.vue";
import CartButton from "@src/Resources/epim/Partials/Shop/cart-button.vue";

export default {
    name: "pim-product-table-list-information-material",
    components: {CartButton, PimProductTableListColumn, PimProductTableListRow, PimProductTableList, GlobalInlineTile},
    props: {
        materials: {
            type: Array,
            required: true
        }
    },
    computed: {
        imageAlternative() {
            return window.pimLocalization.sample.format
        },
        headers() {
            return [
                window.pimLocalization.sample.title,
                window.pimLocalization.sample.art,
                window.pimLocalization.sample.format,
                ''
            ]
        },
    },
    created() {
    }
}
</script>
